export enum AuthErrorCodes {
  AuthCredentialsExpired = 102,
  PasswordResetInvalidChoice = 304,
  PasswordResetBadToken = 303,
}
